import { FetchPolicy } from '@bingads-webui-react/overreact';
import { getDefaultHeaderObj } from '@bingads-webui/overreact-bingads';
import { composeSearchString } from '@bingads-webui-react/overreact-odata';

import { edm } from '../../../../../../env/edm';

export const networkPolicy = FetchPolicy.NetworkOnly;

export function urlDecorator() {
  function decorator(params) {
    const { variables } = params;
    const { locator: { descriptor } } = variables;
    const {
      customer_id: CustomerId,
      account_id: AccountId,
      tag_id: TagId,
    } = descriptor;

    const edmEntity = edm
      .Customers.$withKey(CustomerId)
      .Accounts.$withKey(AccountId)
      .Tags.$withKey(TagId);

    const searchString = composeSearchString(variables, edmEntity, false);
    return `${edmEntity.path}${searchString}`;
  }

  return params => decorator(params);
}

export function headerDecorator(fn) {
  function decorator() {
    return getDefaultHeaderObj();
  }

  return params => decorator(params, fn(params));
}

export const sideEffects = {
  fetch: null,
  refetch: null,
  mutation: null,
  pagination: null,
  add: null,
  destroy: null,
};
